import { motion } from "framer-motion";
import { Camera } from "lucide-react";
import { GALLERY, CONTACT } from "@/data/siteData";

export default function Gallery() {
  return (
    <section id="galeria" data-testid="gallery-section" className="py-20 lg:py-28 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <span className="font-accent uppercase tracking-[0.3em] text-blue-700 text-xs font-bold">04 — Galeria</span>
            <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-none text-4xl sm:text-5xl text-[#0B1120]">
              Treningi, turnieje, <span className="text-blue-700">obozy</span>
            </h2>
          </div>
          <a
            href={CONTACT.facebook}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-facebook-link"
            className="flex items-center gap-2 font-accent text-sm font-bold uppercase tracking-wide text-[#0B1120] border-b-2 border-[#FACC15] pb-1 hover:text-blue-700 transition-colors duration-200"
          >
            <Camera size={18} /> Więcej zdjęć na Facebooku
          </a>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-4">
          {GALLERY.map((photo, i) => (
            <motion.figure
              key={photo.src}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              data-testid={`gallery-photo-${i}`}
              className={`relative group overflow-hidden border-2 border-[#0B1120] ${photo.span}`}
            >
              <img
                src={photo.src}
                alt={photo.label}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0B1120]/90 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="font-accent text-xs font-bold uppercase tracking-widest text-[#FACC15]">{photo.label}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
